import React, {Component} from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardFooter,
  Button,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Form,
  FormFeedback
} from 'reactstrap';

import {compose} from 'recompose';
import {Link, withRouter} from 'react-router-dom';
import {graphql} from 'react-apollo';
import gql from 'graphql-tag';

import * as helper from 'App/util/common/helper';
import messages from 'App/util/common/messages';

@compose(
  withRouter,
  graphql(
    gql`
        mutation($name: String!, $password: String!, $email: String!) {
          signup(name:$name, password:$password, email:$email) {
            me
          }
        }
    `,
    {name: 'signUpMutation'}
  )
)
class Register extends Component {
  state = {
    password: '',
    confirm_password: ' ',
    username: ''
  };

  handleChange = (event) => {
    this.setState(helper.handleInputChange(event));
  };

  formIsValid() {
    return document.getElementById('form-signup') ?
      document.getElementById('form-signup').checkValidity()
      && this.state.password == this.state.confirm_password :
      false;
  }

  handleSubmit(e) {
    e.preventDefault();

    this.performRegistration(
      this.state.email,
      this.state.password,
      this.state.username
    );
  }

  performRegistration(email, password, username) {
    this.props.signUpMutation(
      {
        variables: {
          email: email,
          password: password,
          name: username
        }
      }
    ).then((data) => {
        let callback = (v) => {
        };

        if (!data.errors) {
          callback = (v) => {
            if (v) this.props.history.replace('verify');
          };

          callback = callback.bind(this);
        }

        messages.alert('Thank you' ,'signup sent, please check your emails for confirmation.', callback);
      }
    ).catch((e) => messages.alert('Error', 'An error occured:' + e.message))
  }

  validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  render() {
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="6">
              <Card className="mx-4">
                <CardBody className="p-4">
                  <h1>Register</h1>
                  <p className="text-muted">Create your account</p>
                  <Form id='form-signup'>
                    <InputGroup className="mb-3">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="icon-user"></i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input type="text" name="username"
                             onChange={::this.handleChange}
                             placeholder="Username"
                             required invalid={this.state.username.length < 5}/>
                      <FormFeedback>
                        Please choose a username with a length of min 4 signs.
                      </FormFeedback>
                    </InputGroup>
                    <InputGroup className="mb-3">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>@</InputGroupText>
                      </InputGroupAddon>
                      <Input type="email" name="email"
                             onChange={::this.handleChange}
                             placeholder="Email"
                             invalid={!this.validateEmail(this.state.email)}
                             required/>
                      <FormFeedback>
                        Please specify a valid email address.
                      </FormFeedback>
                    </InputGroup>
                    <InputGroup className="mb-3">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="icon-lock"></i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input type="password" name="password"
                             onChange={::this.handleChange}
                             placeholder="Password"
                             invalid={this.state.password !== this.state.confirm_password}
                      />
                      <FormFeedback>
                        Please type in a password.
                      </FormFeedback>
                    </InputGroup>
                    <InputGroup className="mb-4">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="icon-lock"></i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input type="password" name="confirm_password"
                             onChange={::this.handleChange}
                             placeholder="Repeat password"
                             invalid={this.state.password !== this.state.confirm_password}
                      />
                      <FormFeedback>
                        Please confirm password.
                      </FormFeedback>
                    </InputGroup>
                    <Button type="submit" disabled={!::this.formIsValid()}
                            onClick={::this.handleSubmit} color="success" block>Create Account</Button>
                  </Form>
                </CardBody>
                <CardFooter className="p-4">
                  Already have an account? Just <Link to={helper.getPath('login')}>Login</Link>!
                </CardFooter>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Register;



// WEBPACK FOOTER //
// ./src/views/Pages/Register/Register.js